import { render, staticRenderFns } from "./ShareVK.vue?vue&type=template&id=54ba5449&"
import script from "./ShareVK.vue?vue&type=script&lang=js&"
export * from "./ShareVK.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports